// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu__3UIoC","menuWrapper":"menuWrapper__1g93V","collapsed":"collapsed__1Miur"};